var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import '../../atoms/table/sgdf-table.js';
import '../../atoms/table-next/table-next.js';
import '@shoelace-style/shoelace/dist/components/tooltip/tooltip.js';
import { SessionStatusEnum } from '@sgdf/client';
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { map } from 'lit/directives/map.js';
import { SgdfElement } from '../../internal/sgdf-element.js';
import { withResizeObserver } from '../../internal/with-resize-observer.js';
import { SKELETON_PARTICIPANT } from '../participant.utils.js';
import { iconByMode } from '../participant-card/participant-card.js';
import styles from './participant-list.styles.js';
const getStyle = (status) => `--icon-color: var(--sgdf-color-${status}-600); --icon-size:1.3rem;`;
class SgdfParticipantList extends withResizeObserver(SgdfElement) {
    constructor() {
        super(...arguments);
        this.skeleton = false;
        this.mode = 'link';
        this.currentId = null;
        this.showSorter = true;
        this.columns = [
            {
                id: 'actions',
                enableColumnFilter: false,
                enableSorting: false,
                header: () => 'Actions',
                cell: info => {
                    var _a;
                    const participant = info.row.original;
                    return html `
                    <div class="actions">
                        ${['link', 'validation'].includes(this.mode)
                        ? html `<sl-tooltip
                                      hoist
                                      content="Détail du participant"
                                  >
                                      <sgdf-icon-button
                                          name=${iconByMode.detail}
                                          style=${((_a = participant === null || participant === void 0 ? void 0 : participant.usage_first_name) !== null && _a !== void 0 ? _a : participant.first_name)
                            ? getStyle('neutral')
                            : getStyle('warning')}
                                          @click=${(e) => {
                            e.preventDefault();
                            this.emit('sgdf-participant:navigate', {
                                detail: {
                                    participantId: participant.id,
                                    action: 'detail',
                                },
                            });
                        }}
                                      >
                                      </sgdf-icon-button>
                                  </sl-tooltip>`
                        : ''}
                        ${['link', 'validation'].includes(this.mode)
                        ? html `<sl-tooltip hoist content="Observation">
                                      <sgdf-icon-button
                                          name=${iconByMode.link}
                                          style=${getStyle('neutral')}
                                          @click=${(e) => {
                            e.preventDefault();
                            this.emit('sgdf-participant:navigate', {
                                detail: {
                                    participantId: participant.id,
                                    action: 'link',
                                },
                            });
                        }}
                                      >
                                      </sgdf-icon-button>
                                  </sl-tooltip>`
                        : ''}
                        ${['link', 'check-in'].includes(this.mode)
                        ? html `<sl-tooltip
                                      hoist
                                      content="Émargement &#38; Photo"
                                  >
                                      <sgdf-icon-button
                                          name=${iconByMode['check-in']}
                                          style=${getStyle(participant.signature_available
                            ? 'success'
                            : 'neutral')}
                                          @click=${(e) => {
                            e.preventDefault();
                            this.emit('sgdf-participant:navigate', {
                                detail: {
                                    participantId: participant.id,
                                    action: 'check-in',
                                },
                            });
                        }}
                                      >
                                      </sgdf-icon-button>
                                  </sl-tooltip>`
                        : ''}
                        ${['link', 'validation'].includes(this.mode)
                        ? html `<sl-tooltip
                                      hoist
                                      content="Rédaction de l'avis"
                                  >
                                      <sgdf-icon-button
                                          name=${iconByMode.validation}
                                          style=${getStyle(participant.session_status ===
                            SessionStatusEnum[1]
                            ? 'neutral'
                            : 'success')}
                                          @click=${(e) => {
                            e.preventDefault();
                            this.emit('sgdf-participant:navigate', {
                                detail: {
                                    participantId: participant.id,
                                    action: 'validation',
                                },
                            });
                        }}
                                      >
                                      </sgdf-icon-button>
                                  </sl-tooltip>`
                        : ''}
                    </div>
                `;
                },
            },
            {
                id: 'first_name',
                accessorFn: row => { var _a; return (_a = row.usage_first_name) !== null && _a !== void 0 ? _a : row.first_name; },
                header: () => 'Prénom',
                cell: info => info.getValue(),
            },
            {
                id: 'last_name',
                accessorFn: row => { var _a; return (_a = row.usage_last_name) !== null && _a !== void 0 ? _a : row.last_name; },
                header: () => 'Nom',
                cell: info => info.getValue(),
            },
        ];
    }
    onResize({ width }) {
        this._width = width;
    }
    onTableClick(event) {
        event.stopPropagation();
        this.emit('sgdf-participant:navigate', {
            detail: {
                participantId: event.detail.id,
                action: this.mode,
            },
        });
    }
    onSortFieldUpdate(e) {
        this.emit('sgdf-participants:sort', {
            detail: {
                sortField: e.target.value,
            },
        });
    }
    onSortDirUpdate() {
        this.emit('sgdf-participants:sort', {
            detail: {
                sortDir: this.sortDir === 'asc' ? 'desc' : 'asc',
            },
        });
    }
    render() {
        // NOTE: This value is arbitrary, we don't have a better solution for now
        // It's a bit more than the width of the table in french (which is the largest) and with both links (download and pay)
        // The table width is mostly stable since the with of the amount is fixed and the rest is almost always the same number of characters
        const bigMode = this._width && this._width > 700;
        const skeleton = this.skeleton || this.participants == null;
        const participants = skeleton
            ? SKELETON_PARTICIPANT
            : this.participants;
        return bigMode
            ? this._renderBig(participants)
            : this._renderSmall(skeleton, participants);
    }
    _renderBig(participants) {
        return html `<sgdf-table-next
            .columns=${this.columns}
            .data=${participants}
            .sortField=${this.sortField}
            .sortDir=${this.sortDir}
        ></sgdf-table-next>`;
    }
    _renderSmall(skeleton, participants) {
        return html `${this.showSorter
            ? html `<div class="sort-line">
                          <sl-select
                              @sl-change=${(e) => {
                this.onSortFieldUpdate(e);
            }}
                              .value=${this.sortField}
                          >
                              <sgdf-icon
                                  name="${this.sortField == 'shuffle'
                ? 'shuffle'
                : this.sortDir === 'asc'
                    ? 'arrow-down-a-z'
                    : 'arrow-up-a-z'}"
                                  slot="prefix"
                              ></sgdf-icon>
                              <sl-option value="first_name">Prénom</sl-option>
                              <sl-option value="last_name">Nom</sl-option>
                              <sl-option value="dailytaskteam"
                                  >Équipe de service</sl-option
                              >
                              <sl-option value="nobservations"
                                  >Nb. d'observations</sl-option
                              >
                              <sl-option value="branche">Branche</sl-option>
                              <sl-option value="shuffle">Mélanger</sl-option>
                          </sl-select>
                          <sl-tooltip
                              hoist
                              content="Changer l'ordre de tri / Mélanger"
                          >
                              <sgdf-icon-button
                                  name="${this.sortField == 'shuffle'
                ? 'shuffle'
                : 'arrow-right-arrow-left'}"
                                  class="${this.sortField != 'shuffle'
                ? 'arrow-rotate'
                : ''}"
                                  @click=${() => this.onSortDirUpdate()}
                              >
                              </sgdf-icon-button>
                          </sl-tooltip>
                      </div>`
            : ''}
            <div class="participant-list">
                ${map(participants, participant => html `
                        <sgdf-participant-card
                            .mode=${this.mode}
                            .participant=${participant}
                            .skeleton=${skeleton}
                            .highlight=${this.currentId === participant.id}
                        ></sgdf-participant-card>
                    `)}
            </div> `;
    }
}
SgdfParticipantList.styles = styles;
export default SgdfParticipantList;
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfParticipantList.prototype, "skeleton", void 0);
__decorate([
    property({ type: Array, reflect: true })
], SgdfParticipantList.prototype, "participants", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfParticipantList.prototype, "mode", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfParticipantList.prototype, "currentId", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfParticipantList.prototype, "sortField", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfParticipantList.prototype, "sortDir", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfParticipantList.prototype, "showSorter", void 0);
//# sourceMappingURL=participant-list.component.js.map